module.exports = __webpack_public_path__ + "img/grey-academy-company.0a490357.png";